<section class="funfact-one password-new">
  <div id="myModal" class="modal fade registerConfirm">
    <div class="modal-dialog modal-confirm">
      <div class="modal-content">
        <div class="modal-header justify-content-center">
          <div class="icon-box">
            <i class="fas fa-check"></i>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body text-center">
          <h4 translate>¡Contraseña restablecida correctamente!</h4> 
          <p translate>Ya puedes loguearte con tu nueva contraseña</p>
          
        </div>
      </div>
    </div>
  </div>
  <img src="/assets/images/shapes/testi-shape-1-1.png" class="testimonials-one__background-image" alt="Awesome Image" />
  <div *ngIf="showForm == 2" class="alert alert-danger token-error">
                    <div>{{response.error}}</div>
                </div>
<div class="row justify-content-center" *ngIf="showForm == 1">
  <div class="modal-content col-lg-4 col-md-12">
                
      <div class="modal-header text-center">
        <h4 class="modal-title w-100 font-weight-bold" translate>Nueva Contraseña</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    <form [formGroup]="newpassForm" class="newpassForm"> 
      <div class="modal-body mx-3">
      	<div *ngIf="showError" class="alert alert-danger">
                    <div>{{response.error}}</div>
                </div>
        <div class="form-row">
          <div class="col mb-4">
            <i class="fas fa-lock prefix grey-text login-icon"></i>
            <input type="password" id="defaultForm-pass" class="form-control validate" formControlName="password" [(ngModel)] = "model.password" required>
            <label data-error="wrong" data-success="right" for="defaultForm-pass" translate>Contraseña</label>
            <div *ngIf="newpassForm.controls['password'].invalid && (newpassForm.controls['password'].dirty || newpassForm.controls['password'].touched)" class="alert alert-danger">
                    <div *ngIf="newpassForm.controls['password'].errors.required" translate>Contraseña es requerido.</div>
                  <div *ngIf="newpassForm.controls['password'].errors.minlength" translate>Contraseña debe tener minimo 6 digitos.</div>
                </div>
          </div>
          <div class="col mb-4">
            <i class="fas fa-lock prefix grey-text login-icon"></i>
            <input type="password" id="defaultForm-passconfirm" class="form-control validate" formControlName="passconfirm" [(ngModel)] = "model.passconfirm" required>
            <label data-error="wrong" data-success="right" for="defaultForm-passconfirm" translate>Confirmar Contraseña</label>
            <div *ngIf="newpassForm.controls['passconfirm'].invalid && (newpassForm.controls['passconfirm'].dirty || newpassForm.controls['passconfirm'].touched)" class="alert alert-danger">
                    <div *ngIf="newpassForm.controls['passconfirm'].errors.required" translate>Confirmar contraseña es requerido.</div>
                  <div *ngIf="newpassForm.controls['passconfirm'].errors.minlength" translate>Contraseña debe tener minimo 6 digitos.</div>
                <div *ngIf="(model.password != model.passconfirm) && newpassForm.controls['passconfirm'].touched" translate>Las contraseñas ingresadas no coinciden.</div>
            </div>
          </div>
        </div>
      </div>
    </form>
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-default" (click)="newpass()" [disabled]="newpassForm.invalid" translate>Recuperar Contraseña</button>
      </div>
    </div>
  </div>
</section><!-- /.funfact-one -->